// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__9lfyM","productName":"Table_productName__26yCR"};